import { IPermission } from "@miplatform/types";

export const hasAnyDependentPermissions = (
  permission: IPermission,
  assignedPermissions: string[]
): boolean => {
  return getMissingDependentPermissions(permission, assignedPermissions).length === 0;
};

export const getMissingDependentPermissions = (
  permission: IPermission,
  assignedPermissions: string[]
): string[] => {
  const dependentOnPermissions = permission.dependentOnPermissions || [];

  if (dependentOnPermissions.length === 0) {
    return [];
  }

  const hasDependency = dependentOnPermissions.some((dependentPermissionName) =>
    assignedPermissions.some(
      (assignedPermission) => assignedPermission === dependentPermissionName
    )
  );

  return hasDependency ? [] : dependentOnPermissions;
};
